<template>
    <v-select
        v-model="value"
        :dense="dense"
        :disabled="disabled"
        :items="all.items"
        item-text="nombre"
        item-value="id"
        label="Zonas de influencia"
        @change="change"
        @focus="focus"
    >
    </v-select>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'selectZonainfluencia',
    props: ['value', 'texto', 'disabled', 'dense'],
    data: function() {
        return {
            pvalue: 0,
            ptexto: ''
        };
    },
    computed: {
        ...mapState('zonainfluencia', ['all'])
    },
    methods: {
        ...mapActions('zonainfluencia', ['getAll']),
        change(id) {
            this.$emit('input', id);
            var r = this.all.items.find(function(item, i) {
                if (item.id === id) {
                    return item.nombre;
                }
            });
            this.$emit('texto', r.nombre);
            this.$emit('change', r);
       },
        focus(id) {
            this.pvalue = this.value;
            this.ptexto = this.texto;
        }
    },
    mounted() {
        this.getAll();
    }
};
</script>
